import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './components/App/App';
//import i18n from './i18n';
// the id of the div to render too
let appId = "dpdplat";



// render
ReactDOM.render((
  <BrowserRouter>
    <App />
  </BrowserRouter>
), document.getElementById(appId));


// WEBPACK FOOTER //
// ./src/index.js